import React, { useState, useEffect } from "react";

import { Tooltip, Menu, MenuItem, IconButton, Link } from "@mui/material";
import {
  getSelectedCompany,
  getSelectedBranch,
} from "src/services/httpService";
import { isEmptyObject } from "src/utils/amUtils";

import { useDialog } from "dialog-hook";
import { getCaption } from "src/utils/dictionary";

// const companyOptions = [
//   { id: 1, name: "Air Cargo" },
//   { id: 2, name: "Door To Door" },
//   { id: 3, name: "Contracting" },
// ];

// const branchOptions = [
//   { id: 1, name: "Air Cargo Jed" },
//   { id: 2, name: "Air Cargo DMM" },
//   { id: 3, name: "Door To Door Jed" },
//   { id: 4, name: "Door To Door Dmm" },
//   { id: 5, name: "Contracting" },
// ];

function NavbarBranchDropdown({ companyOptions }) {
  const dialog = useDialog({ ok: "ok", cancel: null });
  const [anchorMenuComp, setAnchorMenuComp] = useState(null);
  const [anchorMenuBranch, setAnchorMenuBranch] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(
    getSelectedCompany() || {}
  );
  const [branchOptions, setBranchOptions] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(
    getSelectedBranch() || {}
  );

  useEffect(() => {
    if (selectedCompany && selectedCompany.branches) {
      setBranchOptions([...selectedCompany.branches]);
      if (!selectedCompany.branches) {
        setSelectedBranch({});
      } else {
        if (selectedBranch) {
          const s = selectedCompany.branches.find(
            (x) => x.id == selectedBranch.id
          );
          setSelectedBranch(s || selectedCompany.branches[0]);
        } else {
          setSelectedBranch(selectedCompany.branches[0]);
        }
      }
    } else {
      setBranchOptions([]);
      setSelectedBranch({});
    }

    if (selectedCompany && Object.keys(selectedCompany).length > 0) {
      localStorage.setItem("selectedCompany", JSON.stringify(selectedCompany));
    } else {
      localStorage.removeItem("selectedCompany");
    }
  }, [selectedCompany.id]);

  useEffect(() => {
    console.log("selectedBranch");
    if (selectedBranch && Object.keys(selectedBranch).length > 0) {
      localStorage.setItem("selectedBranch", JSON.stringify(selectedBranch));
    } else {
      localStorage.removeItem("selectedBranch");
    }
  }, [selectedBranch.id]);

  useEffect(() => {
    if (isEmptyObject(selectedCompany) && companyOptions.length > 0) {
      setSelectedCompany(companyOptions[0]);
    }
    console.log(companyOptions);
  }, [companyOptions.length]);

  const toggleMenuComp = (event) => {
    setAnchorMenuComp(event.currentTarget);
  };

  const closeMenuComp = () => {
    setAnchorMenuComp(null);
  };

  const toggleMenuBranch = (event) => {
    setAnchorMenuBranch(event.currentTarget);
  };

  const closeMenuBranch = () => {
    setAnchorMenuBranch(null);
  };

  const handleCompanyChange = (company) => {
    function a() {
      setSelectedCompany(company);
      window.location.reload();
    }

    dialog({
      title: getCaption("warning"),
      message: getCaption("change_company_reload_warning"),
    })
      .then(a)
      .catch(console.error);
    closeMenuComp();
  };

  const handleBranchChange = (company) => {
    function a() {
      setSelectedBranch(company);
      window.location.reload();
    }
//TODO FIND AN ALTRNATIVE WAY THIS WAY MAKE SYSTEM HANG
//TODO : >> PREVENT CHANGE WITHOUT CONFIRMATION
    // dialog({
    //   title: "Warning!",
    //   message:
    //     "Changing branch will reload page , and you will lose unsaved data. Are you sure you want to change branch?",
    // }).then(a);
a();
    closeMenuBranch();
  };

  return (
    <React.Fragment>
      {/* <button
        onClick={() => {
          dialog({ title: "Warning!", message: "Hello! How are you?" })
            .then(console.log)
            .catch(console.error);
        }}
      >
        Open dialog From Test
      </button> */}
      <Tooltip title={getCaption("click_change_company")}>
        <IconButton
          aria-owns={Boolean(anchorMenuComp) ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={toggleMenuComp}
          color="primary"
          size="small"
        >
          <Link to="/" color="primary">
            {selectedCompany.name || getCaption("select_company")}
          </Link>
        </IconButton>
      </Tooltip>
      <Tooltip title={getCaption("click_change_branch")}>
        <IconButton
          aria-owns={Boolean(anchorMenuComp) ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={toggleMenuBranch}
          color="warning"
          size="small"
        >
          <Link to="/" color="warning">
            {selectedBranch?.name || getCaption("select_branch")}
          </Link>
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenuComp}
        open={Boolean(anchorMenuComp)}
        onClose={closeMenuComp}
      >
        {companyOptions.map((company) => (
          <MenuItem
            key={company.id}
            onClick={() => handleCompanyChange(company)}
          >
            {company.name}
          </MenuItem>
        ))}
      </Menu>

      <Menu
        id="menu-appbar"
        anchorEl={anchorMenuBranch}
        open={Boolean(anchorMenuBranch)}
        onClose={closeMenuBranch}
      >
        {branchOptions.map((branch) => (
          <MenuItem key={branch.id} onClick={() => handleBranchChange(branch)}>
            {branch.name}
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
}

export default NavbarBranchDropdown;
